import { render, staticRenderFns } from "./ecenter-table-sort.vue?vue&type=template&id=6a66f0c0&"
import script from "./ecenter-table-sort.vue?vue&type=script&lang=js&"
export * from "./ecenter-table-sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports